import React, { useState } from 'react';
import { ChevronDown, Check, X, Eye } from 'lucide-react';
import { Button } from '../ui/button';
import { ConflictCompare } from './ConflictCompare';

const TONES = {
  emerald: 'bg-emerald-100 text-emerald-700',
  blue: 'bg-blue-100 text-blue-700',
  rose: 'bg-rose-100 text-rose-700',
  amber: 'bg-amber-100 text-amber-700',
};

export const DiffGroup = ({ group, items, onDecide }) => {
  const [open, setOpen] = useState(group.key !== 'updated');
  return (
    <section data-testid={`publish-group-${group.key}`} className="rounded-2xl bg-white border border-slate-200">
      <button data-testid={`publish-group-toggle-${group.key}`} onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4">
        <span className="flex items-center gap-2 font-bold text-slate-900">
          <span className={`px-2 py-0.5 rounded-full text-xs ${TONES[group.tone]}`}>{items.length}</span>{group.title}
        </span>
        <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <ul className="divide-y divide-slate-100 border-t border-slate-100">
          {items.map(it => <DiffRow key={it.key} item={it} group={group.key} onDecide={onDecide} />)}
        </ul>
      )}
    </section>
  );
};

const DiffRow = ({ item, group, onDecide }) => {
  const [compare, setCompare] = useState(false);
  const tid = item.key.replace(/[^a-zA-Z0-9_-]/g, '-');
  return (
    <li data-testid={`publish-item-${tid}`} className="p-4 space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-xs px-2 py-0.5 rounded bg-slate-100 text-slate-600">{item.label}</span>
        <span className="font-semibold text-slate-900 flex-1 min-w-[180px]">{item.title || item.id}</span>
        {item.reason && <span className="text-xs text-amber-700">{item.reason}</span>}
        {group === 'deleted' && (
          item.decision === 'approve_delete'
            ? <Button size="sm" variant="outline" data-testid={`publish-undo-delete-${tid}`} onClick={() => onDecide(item.key, 'clear')}><X className="w-4 h-4 ms-1" />إلغاء الموافقة</Button>
            : <Button size="sm" data-testid={`publish-approve-delete-${tid}`} className="bg-rose-600 hover:bg-rose-700 text-white" onClick={() => onDecide(item.key, 'approve_delete')}><Check className="w-4 h-4 ms-1" />موافقة على الحذف</Button>
        )}
        {group === 'deleted' && item.decision === 'approve_delete' && <span className="text-xs text-rose-700 font-bold">سيُحذف</span>}
        {group === 'conflicts' && (
          <>
            {item.decision && <span data-testid={`publish-decision-${tid}`} className="text-xs font-bold text-blue-700">{item.decision === 'preview' ? 'اعتماد نسخة المعاينة' : 'الإبقاء على نسخة الموقع الحي'}</span>}
            <Button size="sm" variant="outline" data-testid={`publish-compare-${tid}`} onClick={() => setCompare(!compare)}><Eye className="w-4 h-4 ms-1" />مقارنة واختيار</Button>
          </>
        )}
      </div>
      {compare && <ConflictCompare item={item} onDecide={onDecide} />}
    </li>
  );
};
